export const WorkflowTasks = {
    INTERVIEW_COMPLETED: "INTERVIEW_COMPLETED",
    AUTHORIZE_CRA: "AUTHORIZE_CRA",
    AUTHORIZE_CRA_SPOUSE: "AUTHORIZE_CRA_SPOUSE",    
    AUTHORIZE_RQ: "AUTHORIZE_RQ",
    AUTHORIZE_RQ_SPOUSE: "AUTHORIZE_RQ_SPOUSE",
    CLIENT_CALL_DOCUMENTS_VIR: "CLIENT_CALL_DOCUMENTS_VIR",
    CLIENT_CALL_PAYMENT_VIR: "CLIENT_CALL_PAYMENT_VIR",
    CONFIRM_ID: "CONFIRM_ID",
    CONFIRM_ID_SPOUSE: "CONFIRM_ID_SPOUSE",
    DOCS_UPLOADED: "DOCS_UPLOADED",
    FILE_RETURN: "FILE_RETURN",
    FILE_RETURN_VIR: "FILE_RETURN_VIR",
    FILE_RETURN_RTE: "FILE_RETURN_RTE",
    RETURN_PREPARED: "RETURN_PREPARED",
    RETURN_REVIEWED: "RETURN_REVIEWED",
    RETURN_REVIEWED_RQ: "RETURN_REVIEWED_RQ",
    PAYMENT_PREPARED: "PAYMENT_PREPARED",
    PAYMENT_RECEIVED: "PAYMENT_RECEIVED",
    PAYMENT_RECEIVED_RTE: "PAYMENT_RECEIVED_RTE",
    RETURN_FILED: "RETURN_FILED",
    RETURN_FILED_SPOUSE: "RETURN_FILED_SPOUSE",    
    REVIEW_RETURN: "REVIEW_RETURN",
    TAX_PRO_ASSIGNED: "TAX_PRO_ASSIGNED",
    FINALIZE_RETURN: "FINALIZE_RETURN",
    CLIENT_APPROVALS: "CLIENT_APPROVALS",
    TRANSFER_AND_RECEIPT: "TRANSFER_AND_RECEIPT",
    VIR_CONFIRM_UPLOAD: "VIR_CONFIRM_UPLOAD",
    POA_P: "POA_P",
    RC71_P: "RC71_P",
    RECEIPT_P: "RECEIPT_P",
    VIR_READY_TO_FILE: "VIR_READY_TO_FILE",
    DOCUMENT_REVIEW: "DOCUMENT_REVIEW",
    SIGNATUREPAGE_P: "SIGNATUREPAGE_P",
    SIGNATUREPAGE_S: "SIGNATUREPAGE_S"
}

export const AdditionalDocTasks = {
    T1032_P: "T1032_P",
    T1032_S: "T1032_S",
    T1135_P: "T1135_P",
    T1135_S: "T1135_S",
    T2091_P: "T2091_P",
    T2091_S: "T2091_S",
    T2202_P: "T2202_P",
    T2202_S: "T2202_S",
    POMA_P: "POMA_P",
    POMA_S: "POMA_S",
    POMQCA_P: "POMQCA_P",
    POMQCA_S: "POMQCA_S"
}


export const AdditionalVirDocTasks = {
    POA_P: "POA_P",
    RC71_P: "RC71_P"
}

export const SecondaryTasks = [
    WorkflowTasks.AUTHORIZE_CRA_SPOUSE,
    WorkflowTasks.AUTHORIZE_RQ_SPOUSE,
    WorkflowTasks.AUTHORIZE_RQ,
    WorkflowTasks.AUTHORIZE_RQ_SPOUSE,
    WorkflowTasks.CONFIRM_ID_SPOUSE,
    WorkflowTasks.RETURN_REVIEWED_RQ,
    WorkflowTasks.RETURN_FILED_SPOUSE,
    WorkflowTasks.POA_P,
    WorkflowTasks.RC71_P
];

export const AuthorizeTasks = [
    WorkflowTasks.AUTHORIZE_CRA,
    WorkflowTasks.AUTHORIZE_CRA_SPOUSE,
    WorkflowTasks.AUTHORIZE_RQ,
    WorkflowTasks.AUTHORIZE_RQ_SPOUSE
];

export const ConfirmIdTasks = [
    WorkflowTasks.CONFIRM_ID,
    WorkflowTasks.CONFIRM_ID_SPOUSE
];

export const ReviewTasks = [
    WorkflowTasks.RETURN_REVIEWED,
    WorkflowTasks.RETURN_REVIEWED_RQ,
    ...Object.keys(AdditionalDocTasks)
];

export const VirReviewTasks = [
    WorkflowTasks.RETURN_REVIEWED,
    WorkflowTasks.VIR_CONFIRM_UPLOAD,
    ...Object.keys(AdditionalVirDocTasks)
];

export const VIRCCDocumentsTasks = [
    WorkflowTasks.RETURN_REVIEWED,
    WorkflowTasks.VIR_CONFIRM_UPLOAD,
    ...Object.keys(AdditionalVirDocTasks)
];

export const VIRCCPaymentTasks = [
    WorkflowTasks.RETURN_REVIEWED,
    ...Object.keys(AdditionalVirDocTasks),
    WorkflowTasks.VIR_CONFIRM_UPLOAD,
    WorkflowTasks.RETURN_FILED
];


export const FiledTasks = [
    WorkflowTasks.RETURN_FILED,
    WorkflowTasks.RETURN_FILED_SPOUSE
];

export const SuccessfulStatus = "COMPLETEDSUCCESSFULLY";

export const VirWorkflowStateIdentifiers = {
    VIR_COMPLETE: "VIR_COMPLETE",
    VIR_FILE_RETURN: "VIR_FILE_RETURN",
    VIR_CLIENT_CALL_DOCUMENT: "VIR_CLIENT_CALL_DOCUMENT",
    VIR_CLIENT_CALL_PAYMENT: "VIR_CLIENT_CALL_PAYMENT",
    VIR_REVIEW_RETURN: "VIR_REVIEW_RETURN",
    VIR_CUSTOMER_ACTIONS: "VIR_CUSTOMER_ACTIONS",
    VIR_INTERVIEW: "VIR_INTERVIEW",
    VIR_CREATED: "VIR_CREATED"
};

export const WorkFlowCompletedStates = ["VDO_COMPLETE", "VDO_COMPLETE_C", "VDO_COMPLETE_RQC", "VDO_COMPLETE_RQ"]